import { nanoId } from '@/helpers'

export const set = ({ dispatch, commit }, transferDocumentList) => {
  return new Promise((resolve, reject) => {
    if (!Array.isArray(transferDocumentList)) reject(new Error(`${transferDocumentList} must be an array`))
    Promise.all(
      transferDocumentList.map(transferDocument => {
        dispatch('insertDetail', transferDocument)
      })
    ).then(() => {
      resolve()
    }, (err) => {
      reject(err)
    })
  })
}

export const empty = ({ dispatch, commit }) => {
  return new Promise((resolve) => {
    dispatch('emptyDetail').then(() => {
      commit('SET_LIST', [])
      resolve()
    })
  })
}

export const emptyDetail = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_SELECTED_KEY', undefined)
    commit('SET_DOCUMENT_NATURE', undefined)
    commit('SET_REPRESENTATION_TYPE', undefined)
    commit('SET_DOCUMENT_TYPE', undefined)
    commit('SET_REPOSITORY_NAME', undefined)
    commit('SET_URL', undefined)
    commit('SET_REFERENCE', undefined)
    resolve()
  })
}

export const upsertDetail = ({commit, dispatch, state}, transferDocument) => {
  if (transferDocument.key) {
    return dispatch('updateDetail', transferDocument)
  } else {
    return dispatch('insertDetail', transferDocument)
  }
}

export const insertDetail = ({ dispatch, commit, state, getters }, transferDocument) => {
  let document = {
    key: nanoId(8),
    ...transferDocument
  }
  state.list.push(document)
  return Promise.resolve()
}

export const updateDetail = ({ dispatch, commit, state, getters }, transferDocument) => {
  let documentKey = transferDocument.key
  let documentInList = state.list.find(document => document.key === documentKey)
  Object.assign(documentInList, transferDocument)
  return Promise.resolve()
}
